<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="cp gray400 mr-4" @click="changeScreen('add', '', '', 'moreOptions')" />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">Add to your post</h4>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="font-black ml-auto cp font20" @click="hide" />
    </div>
    <div
      :class="`d-flex align-items-center mb-2 p-3 rounded fw700 font14 ${option.disabled ? 'noHover' : 'cp'}`"
      v-for="option in moreOptionList"
      :key="option.name"
      :style="{ background: option.selected ? getPrimaryColor() : '#F8FAFD', color: option.disabled ? '#94A3B8' : option.selected ? '#ffffff' : '#647490' }"
      @click="() => !option.disabled && changeScreen(option.screen, '', '', 'moreOptions')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        v-if="option.icon === 'tag' && !option.selected"
        :style="{ fill: option.disabled ? '#94A3B8' : getPrimaryColor() }"
        class="hw20 mr-2 min-w-20"
      >
        <path
          d="M32 229.5V80c0-8.8 7.2-16 16-16H197.5c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3L262.6 428.1c-12.5 12.5-32.8 12.5-45.3 0l-176-176L18.7 274.7l22.6-22.6c-6-6-9.4-14.1-9.4-22.6zm-32 0c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80V229.5zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 24"
        v-else-if="option.icon === 'newspaper' && !option.selected"
        :style="{ fill: option.disabled ? '#94A3B8' : getPrimaryColor() }"
        class="hw20 mr-2 min-w-20"
      >
        <path
          d="M20.9053 3H8.40527C7.35059 3 6.53027 3.85938 6.53027 4.875V18C6.53027 18.7031 5.94434 19.25 5.28027 19.25C4.57715 19.25 4.03027 18.7031 4.03027 18V6.125C4.03027 5.8125 3.71777 5.5 3.40527 5.5C3.05371 5.5 2.78027 5.8125 2.78027 6.125V18C2.78027 19.4062 3.87402 20.5 5.28027 20.5H19.6553C21.374 20.5 22.7803 19.1328 22.7803 17.375V4.875C22.7803 3.85938 21.9209 3 20.9053 3ZM21.5303 17.375C21.5303 18.4297 20.6709 19.25 19.6553 19.25H7.42871C7.62402 18.8984 7.78027 18.4688 7.78027 18V4.875C7.78027 4.5625 8.05371 4.25 8.40527 4.25H20.9053C21.2178 4.25 21.5303 4.5625 21.5303 4.875V17.375ZM13.4053 13.625H9.65527C9.30371 13.625 9.03027 13.9375 9.03027 14.25C9.03027 14.6016 9.30371 14.875 9.65527 14.875H13.4053C13.7178 14.875 14.0303 14.6016 14.0303 14.25C14.0303 13.9375 13.7178 13.625 13.4053 13.625ZM19.6553 13.625H15.9053C15.5537 13.625 15.2803 13.9375 15.2803 14.25C15.2803 14.6016 15.5537 14.875 15.9053 14.875H19.6553C19.9678 14.875 20.2803 14.6016 20.2803 14.25C20.2803 13.9375 19.9678 13.625 19.6553 13.625ZM13.4053 16.125H9.65527C9.30371 16.125 9.03027 16.4375 9.03027 16.75C9.03027 17.1016 9.30371 17.375 9.65527 17.375H13.4053C13.7178 17.375 14.0303 17.1016 14.0303 16.75C14.0303 16.4375 13.7178 16.125 13.4053 16.125ZM19.6553 16.125H15.9053C15.5537 16.125 15.2803 16.4375 15.2803 16.75C15.2803 17.1016 15.5537 17.375 15.9053 17.375H19.6553C19.9678 17.375 20.2803 17.1016 20.2803 16.75C20.2803 16.4375 19.9678 16.125 19.6553 16.125ZM19.0303 5.5H10.2803C9.57715 5.5 9.03027 6.08594 9.03027 6.75V10.5C9.03027 11.2031 9.57715 11.75 10.2803 11.75H19.0303C19.6943 11.75 20.2803 11.2031 20.2803 10.5V6.75C20.2803 6.08594 19.6943 5.5 19.0303 5.5ZM19.0303 10.5H10.2803V6.75H19.0303V10.5Z"
        />
      </svg>
      <svg
        v-else-if="option.icon === 'newspaper' && option.selected"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ fill: option.disabled ? '#94A3B8' : getPrimaryColor() }"
        class="hw20 mr-2 min-w-20"
      >
        <path
          d="M18.75 0H5C4.29688 0 3.75 0.585938 3.75 1.25V14.375C3.75 14.7266 3.4375 15 3.125 15C2.77344 15 2.5 14.7266 2.5 14.375V2.5H1.25C0.546875 2.5 0 3.08594 0 3.75V15C0 16.4062 1.09375 17.5 2.5 17.5H17.5C18.8672 17.5 20 16.4062 20 15V1.25C20 0.585938 19.4141 0 18.75 0ZM10.625 15H6.875C6.52344 15 6.25 14.7266 6.25 14.375C6.25 14.0625 6.52344 13.75 6.875 13.75H10.625C10.9375 13.75 11.25 14.0625 11.25 14.375C11.25 14.7266 10.9375 15 10.625 15ZM10.625 11.25H6.875C6.52344 11.25 6.25 10.9766 6.25 10.625C6.25 10.3125 6.52344 10 6.875 10H10.625C10.9375 10 11.25 10.3125 11.25 10.625C11.25 10.9766 10.9375 11.25 10.625 11.25ZM16.875 15H13.125C12.7734 15 12.5 14.7266 12.5 14.375C12.5 14.0625 12.7734 13.75 13.125 13.75H16.875C17.1875 13.75 17.5 14.0625 17.5 14.375C17.5 14.7266 17.1875 15 16.875 15ZM16.875 11.25H13.125C12.7734 11.25 12.5 10.9766 12.5 10.625C12.5 10.3125 12.7734 10 13.125 10H16.875C17.1875 10 17.5 10.3125 17.5 10.625C17.5 10.9766 17.1875 11.25 16.875 11.25ZM17.5 6.875C17.5 7.22656 17.1875 7.5 16.875 7.5H6.875C6.52344 7.5 6.25 7.22656 6.25 6.875V3.125C6.25 2.8125 6.52344 2.5 6.875 2.5H16.875C17.1875 2.5 17.5 2.8125 17.5 3.125V6.875Z"
          fill="#2A71D4"
        />
      </svg>
      <font-awesome-icon
        v-else-if="option.icon"
        :style="{ color: option.disabled ? '#94A3B8' : option.selected ? '#ffffff' : getPrimaryColor() }"
        :icon="[option.selected ? 'fas' : 'fal', option.icon]"
        class="mr-2 font20 min-w-20"
      />
      <svg
        v-else-if="option.name === 'Add celebration'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="hw20 mr-2 min-w-20"
        :style="{ fill: option.disabled ? '#94A3B8' : option.selected ? '#ffffff' : getPrimaryColor() }"
      >
        <path
          v-if="option.selected"
          d="M503.5 42.3c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-10 8.5c-5.8 4.9-13.2 7.5-20.7 7.3c-42.5-1.1-78.3 31.7-80.8 74.2l-1.8 30c-1 16.6-15 29.4-31.6 29c-19.4-.5-38.2 6.1-53 18.6l-10 8.5c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l10-8.5c5.8-4.9 13.2-7.5 20.7-7.3c42.5 1.1 78.3-31.7 80.8-74.2l1.8-30c1-16.6 15-29.4 31.6-29c19.4 .5 38.2-6.1 53-18.6l10-8.5zM232 0c-13.3 0-24 10.7-24 24c0 30.5-10.1 54.1-20.3 70.2c-5.1 8.1-10.2 14.2-13.8 18.2c-1.8 2-3.3 3.4-4.2 4.3c-.5 .4-.8 .7-1 .9l-.1 .1 0 0c-10.1 8.5-11.4 23.6-3 33.7c8.5 10.2 23.6 11.6 33.8 3.1L184 136c15.4 18.4 15.4 18.4 15.4 18.4l0 0 0 0 .1-.1 .2-.2 .7-.6c.5-.5 1.2-1.1 2.1-1.9c1.7-1.6 4-3.8 6.6-6.7c5.3-5.8 12.3-14.2 19.2-25.1C242.1 97.9 256 65.5 256 24c0-13.3-10.7-24-24-24zM96 32C96 14.3 81.7 0 64 0S32 14.3 32 32s14.3 32 32 32s32-14.3 32-32zM512 160c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM480 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM395.5 342.1l.1-.1c.2-.2 .5-.6 .9-1.1c.9-1.1 2.3-2.8 4.3-4.8c4-4.2 10-9.7 17.8-15.1c15.6-10.7 37.9-20.2 66.8-17c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5c-43.1-4.8-76.8 9.7-99.2 25c-11.2 7.6-19.7 15.6-25.5 21.6c-2.9 3.1-5.2 5.7-6.7 7.6c-.8 1-1.4 1.8-1.9 2.4l-.6 .8-.2 .3-.1 .1 0 0 0 0c0 0 0 0 19.5 14l-19.5-13.9c-7.7 10.8-5.2 25.8 5.6 33.5c10.7 7.7 25.7 5.2 33.4-5.5l0 0zM121.2 192.7c-10.6 2.3-19.4 9.9-23.2 20L83.1 252.5 259.5 428.9 299.2 414c10.2-3.8 17.7-12.6 20-23.2s-1-21.7-8.6-29.4l-160-160c-7.7-7.7-18.8-11-29.4-8.6zM70.8 285.4L48.2 345.6 166.4 463.8l60.2-22.6L70.8 285.4zm62.7 190.7L35.9 378.5 2 468.8c-4.4 11.8-1.5 25 7.3 33.9s22.1 11.7 33.9 7.3l90.3-33.8z"
        />
        <path
          v-else
          d="M150.6 201.4C144.6 195.3 136.4 192 127.9 192c-2.234 0-4.482 .2269-6.711 .6996c-10.62 2.312-19.37 9.844-23.19 20.03l-95.1 256c-4.406 11.75-1.531 25 7.344 33.88C15.47 508.7 23.66 512 32 512c3.781 0 7.594-.6563 11.25-2.031l255.1-96c10.19-3.812 17.72-12.56 20.03-23.19c2.281-10.62-.9683-21.72-8.656-29.41L150.6 201.4zM32 479.1l28.71-76.66l47.93 47.93L32 479.1zM141.5 438.9l-68.51-68.51l22.54-60.2l106.2 106.2L141.5 438.9zM234.6 404L107.9 277.3l19.98-53.26c.0293-.0078-.0254 0 0 0l160.1 159.1L234.6 404zM496 256h-10.88c-50.63 0-98.06 25.78-130.2 70.69c-5.125 7.219-3.469 17.19 3.719 22.34C361.5 351 364.8 352 368 352c4.969 0 9.906-2.344 13.03-6.688C407 308.9 444.1 288 485.1 288H496C504.8 288 512 280.8 512 272S504.8 256 496 256zM176 160C179.2 160 182.5 159 185.3 157C230.2 124.9 256 77.5 256 26.88V16c0-8.844-7.156-16-15.1-16c-8.844 0-16 7.156-16 16v10.88c0 40.16-20.88 78.09-57.31 104.1C159.5 136.1 157.8 146.1 162.1 153.3C166.1 157.7 171 160 176 160zM64 56c13.26 0 24-10.75 24-24c0-13.26-10.74-24-24-24c-13.25 0-23.1 10.74-23.1 24C40.01 45.25 50.75 56 64 56zM480 424c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C504 434.7 493.3 424 480 424zM480 136c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C504 146.7 493.3 136 480 136zM382.7 175.1c19.84-23.5 18.41-46 17.25-64.06c-1-16.12-1.75-27.75 9.781-41.44c11.47-13.59 22.81-14.62 38.5-16.03c17.88-1.625 40.09-3.656 60.03-27.28c5.719-6.75 4.844-16.84-1.906-22.53c-6.688-5.656-16.81-4.844-22.53 1.906c-11.47 13.59-22.81 14.62-38.5 16.03c-17.88 1.625-40.09 3.656-60.03 27.28c-19.84 23.5-18.41 46-17.25 64.06c1 16.12 1.75 27.75-9.781 41.44c-11.44 13.53-22.75 14.56-38.44 15.97c-17.88 1.594-40.09 3.594-60 27.22c-5.719 6.75-4.844 16.84 1.906 22.53C264.7 222.8 268.3 224 272 224c4.531 0 9.062-1.938 12.22-5.688c11.44-13.53 22.75-14.56 38.44-15.97C340.5 200.8 362.8 198.8 382.7 175.1z"
        />
      </svg>
      {{ option.name }}
      <font-awesome-icon v-if="option.selected" :icon="['fas', 'check']" class="font-white ml-auto" />
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { faNewspaper, faCalendar, faBriefcase } from "@fortawesome/pro-solid-svg-icons"

library.add(faNewspaper, faCalendar, faBriefcase)

export default {
  name: "MoreOptionsScreen",
  props: {
    changeScreen: Function,
    selectedOptions: Array,
    disabledOptions: Array,
    hide: Function,
  },
  created() {
    // console.log("selectedOption ->", this.selectedOptions);
    // console.log("disabledOption ->", this.disabledOptions);
    // this.disabledOptions = [...this.disabledOptions, "pressRelease", "event", "job"]
    this.moreOptionList = this.moreOptionList.map(o => {
      if (this.selectedOptions.includes(o.screen)) {
        return { ...o, selected: true }
      } else if (this.disabledOptions.includes(o.screen)) {
        return { ...o, disabled: true }
      } else {
        return { ...o, selected: false, disabled: false }
      }
    })
  },
  data() {
    return {
      moreOptionList: [
        {
          // selected: false,
          name: "Add image/video",
          screen: "image",
          // disabled: false,
          icon: "image",
        },
        {
          // selected: false,
          name: "Add feeling",
          // disabled: false,
          screen: "feelings",
          icon: "comment-alt-smile",
        },
        {
          screen: "celebrations",
          // selected: false,
          name: "Add celebration",
          // disabled: false,
        },
        {
          // selected: false,
          name: "Add tags",
          screen: "tags",
          // disabled: false,
          icon: "tag",
        },
        {
          // selected: false,
          screen: "question",
          name: "Mark as question",
          // disabled: false,
          icon: "question-circle",
        },
        {
          // selected: false,
          name: "Create a poll",
          // disabled: false,
          icon: "poll",
          screen: "poll",
        },
        {
          // selected: false,
          screen: "pressRelease",
          name: "Press release",
          // disabled: false,
          icon: "newspaper",
        },
        {
          screen: "event",
          // selected: false,
          name: "Create an event",
          // disabled: false,
          icon: "calendar",
        },
        {
          // selected: false,
          screen: "job",
          name: "We are hiring",
          // disabled: false,
          icon: "briefcase",
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.font14:hover {
  background: #cbd5e1 !important;
}
.noHover:hover {
  background: #f8fafd !important;
}
.min-w-20 {
  min-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/MoreOptions.vue